import { useAuth } from '../AuthContext';
import { api } from '../api';

const DEV_LOGIN = process.env.REACT_APP_DEV_LOGIN === 'true';

export default function Login() {
  const { setUser } = useAuth();

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const handleLogin = () => {
    const redirectUrl = window.location.origin + '/auth/callback';
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  // Local development only (REACT_APP_DEV_LOGIN=true)
  const handleDevLogin = () => {
    api.post('/auth/dev-login').then(setUser);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 to-slate-800">
      <div className="bg-white rounded-3xl shadow-2xl p-10 w-full max-w-sm text-center">
        <div className="w-14 h-14 bg-[#0288D1] rounded-2xl flex items-center justify-center mx-auto mb-6">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M9 18V5l12-2v13"/>
            <circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>
          </svg>
        </div>
        <h1 className="text-2xl font-extrabold text-slate-900 font-manrope mb-8">My Social Dance Studio</h1>

        <button
          onClick={handleLogin}
          data-testid="google-login-btn"
          className="w-full flex items-center justify-center gap-3 border border-slate-200 rounded-xl px-4 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition-colors shadow-sm"
        >
          <svg width="18" height="18" viewBox="0 0 18 18">
            <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 0 0 2.38-5.88c0-.57-.05-.66-.15-1.18z"/>
            <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2.01c-.72.48-1.63.76-2.7.76-2.08 0-3.84-1.41-4.47-3.29H1.86v2.07A8 8 0 0 0 8.98 17z"/>
            <path fill="#FBBC05" d="M4.51 10.52A4.8 4.8 0 0 1 4.26 9c0-.53.09-1.04.25-1.52V5.41H1.86A8 8 0 0 0 .98 9c0 1.29.31 2.51.88 3.59l2.65-2.07z"/>
            <path fill="#EA4335" d="M8.98 3.58c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 0 0 .98 9l2.88 2.07C4.14 4.99 5.9 3.58 8.98 3.58z"/>
          </svg>
          Se connecter avec Google
        </button>

        {DEV_LOGIN && (
          <button
            onClick={handleDevLogin}
            data-testid="dev-login-btn"
            className="w-full mt-3 rounded-xl px-4 py-3 text-sm font-semibold text-white bg-amber-500 hover:bg-amber-600 transition-colors"
          >
            Connexion locale (dev)
          </button>
        )}

        <p className="text-xs text-slate-300 mt-6">
          Accès restreint — sur invitation uniquement
        </p>
      </div>
    </div>
  );
}
